import React from "react";

import { Container, Modal, Button } from "react-bootstrap";

import { FaTrashAlt } from "react-icons/fa";
import { deleteUser } from "../../../controllers/ControllerUser";

export default function DeleteUserModal(props) {
  const {
    showDeleteUserModal,
    setShowDeleteUserModal,
    getData,
    code3c_id,
    token,
  } = props;

  function clearFields() {
    setShowDeleteUserModal(false);
  }

  function handleClose() {
    setShowDeleteUserModal(!showDeleteUserModal);
  }

  async function handleDeleteUser() {
    const response = await deleteUser(
      showDeleteUserModal.name,
      showDeleteUserModal.id,
      token,
    );
    if (response) {
      getData(code3c_id);
      clearFields();
    }
  }

  return (
    <Container className="ubuntuFont">
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        className="ubuntuFont"
        show={showDeleteUserModal.show}
        onHide={handleClose}
        centered
      >
        <Modal.Header className="text-center" closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center"
          >
            <FaTrashAlt className="text-danger" />
            &emsp;Apagar Produtor?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          Tem certeza que quer apagar o usuário:&nbsp;
          {showDeleteUserModal.name}?
          <Container className="my-3">
            <Button
              variant="danger"
              className="mr-2"
              onClick={() => handleDeleteUser()}
              style={{ width: "120px" }}
            >
              Apagar
            </Button>
            <Button
              variant="dark"
              onClick={() => handleClose()}
              style={{ width: "120px" }}
            >
              Cancelar
            </Button>
          </Container>
        </Modal.Body>
      </Modal>
    </Container>
  );
}
